// Centralized experiment-related constants
export const DEFAULT_EXPERIMENT_WEEKS = 8; // Default duration for new experiments


// Margen mínimo que exige el ERP para plantear un cambio. Espejo de MIN_ERP_LEAD_DAYS en
// backend/src/services/experiment-scheduling.gateway.ts — si cambia allí, cambia aquí.
export const MIN_ERP_LEAD_DAYS = 3;

/** true si esa fecha de inicio no da el margen que exige el ERP (misma cuenta que el gateway). */
export const startsTooSoonForErp = (value) => {
  if (!value) return false;
  const start = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(start.getTime())) return false;
  const day = (d) => { const c = new Date(d); c.setHours(0, 0, 0, 0); return c.getTime(); };
  return Math.round((day(start) - day(new Date())) / 86400000) < MIN_ERP_LEAD_DAYS;
};

/** Primera fecha de inicio que el ERP aceptaría: se usa como minDate en los calendarios. */
export const earliestErpStartDate = () => {
  const first = new Date();
  first.setHours(0, 0, 0, 0);
  first.setDate(first.getDate() + MIN_ERP_LEAD_DAYS);
  return first;
};
